module.exports = __webpack_public_path__ + "media/assets/img/screenshots/pbs-de03b5ce03ac46e3e5f22296777d2118.png";